import Icon from 'veui/components/Icon'

Icon.register({
  plus: {
    paths: [
      {
        d: 'M22 22V3a2 2 0 114 0v19h19a2 2 0 110 4H26v19a2 2 0 11-4 0V26H3a2 2 0 110-4h19z'
      }
    ],
    width: '48',
    height: '48'
  }
})
